module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inventory-history-page"
  }, [_c('div', {
    staticClass: "foo inventory-history-page__head"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_inventory_history')))]), _vm._v(" "), _c('p', {
    staticClass: "inventory-history-page__subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_inventory_history_subtitle')))])]), _vm._v(" "), _c('button', {
    staticClass: "inventory-btn inventory-btn--primary",
    on: {
      "click": _vm.openAddNewInventory
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_create_inventory')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "inventory-history-page__panel"
  }, [_c('div', {
    staticClass: "inventory-history-page__dates"
  }, [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_from')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_to')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inventory-history-page__search-wrap"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_search')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search')
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.groupedBuckets.length > 0) ? _c('div', {
    staticClass: "inventory-history-page__chips"
  }, [_c('button', {
    staticClass: "inventory-chip",
    class: {
      'inventory-chip--active': _vm.isBucketActive(null)
    },
    on: {
      "click": function($event) {
        return _vm.selectBucket(null)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.locale.t('label_all')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.groupedBuckets), function(bucket) {
    return _c('button', {
      key: bucket.key,
      staticClass: "inventory-chip",
      class: {
        'inventory-chip--active': _vm.isBucketActive(bucket.key)
      },
      on: {
        "click": function($event) {
          return _vm.selectBucket(bucket.key)
        }
      }
    }, [_vm._v("\n        " + _vm._s(bucket.label) + " (" + _vm._s(bucket.count) + ")\n      ")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content table-responsive table-full-width inventory-history-page__panel"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.locale.t('label_picture')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_inventory_quantity')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_created_by')))])])]), _vm._v(" "), _c('tbody', [(_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : (_vm.filteredItems.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_data_for_period')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredItems), function(item) {
    return _c('tr', {
      key: item.id + '-' + item.inventoryTimestamp
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(_vm.normalizeImage(item)) ? _c('img', {
      staticClass: "user-avatar-sm cropped1",
      attrs: {
        "src": _vm.normalizeImage(item)
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(_vm.getDisplayName(item)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_inventory_quantity')
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_date')
      }
    }, [_vm._v(_vm._s(_vm.formatDateTime(item.inventoryTimestamp)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_created_by')
      }
    }, [_vm._v(_vm._s(item.createdBy))])])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00724366!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inventory/InventoryHistory.vue
// module id = 695
// module chunks = 0